export default "__VITE_ASSET__msxlXQ7l__"